/*
    Copyright 2022-2025, Techwise Integrated Security, LLC
*/

import { InventoryTransfer, Pagination } from "../../utils/Interfaces";
import { buildGetRequest } from "../../utils/Requests";

export function getMaterialsTransferHistory(startDate: string, endDate: string) {
    return buildGetRequest<Pagination<InventoryTransfer>>(`/api/inventory/transfers/filter/${startDate}/${endDate}`);
}
